import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53739)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1378 41.3792H0.862108C0.386034 41.3792 0 40.9932 0 40.5171V9.48271C0 9.00664 0.386034 8.62061 0.862108 8.62061H49.1379C49.614 8.62061 50 9.00664 50 9.48271V40.5171C49.9999 40.9933 49.6139 41.3792 49.1378 41.3792Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9999 20.6895H22.4137V8.62061H13.793V20.6895H0V29.3102H13.793V41.3791H22.4137V29.3102H49.9999V20.6895Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9999 22.4136H20.6896V8.62061H15.5173V22.4136H0V27.5861H15.5173V41.3791H20.6896V27.5861H49.9999V22.4136Z",
					fill: "#41479B"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53739",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgNoFlag);
export { ForwardRef as ReactComponent };
